import { GameConfig } from "../config/game-config";
import { store } from "../stores";
import { IAssetsConfig } from "../types/game-config-type";

const sprites: IAssetsConfig = GameConfig.sprites;
const cueSticks: IAssetsConfig = GameConfig.cueSticks;
const sounds: IAssetsConfig = GameConfig.sounds;

/***
 * All of the resources used in the main table canvas are loaded in this class.
 */
class ResourcesSingleton {
  private sprites: Map<string, HTMLImageElement>;
  private cueSticks: Map<string, HTMLImageElement>;
  private sounds: Map<string, HTMLAudioElement>;

  constructor() {
    this.sprites = new Map<string, HTMLImageElement>();
    this.cueSticks = new Map<string, HTMLImageElement>();
    this.sounds = new Map<string, HTMLAudioElement>();
  }

  public async loadGameAssets(): Promise<void> {
    await this.loadGameSounds().catch((e) => {
      console.log(" Error  ", e);
    });
    await this.loadGameSprites();
    await this.loadCueSticks();
  }

  public getSprite(key: string): HTMLImageElement {
    //@ts-ignore
    return this.sprites.get(key);
  }

  public getCueSticks(key: string): HTMLImageElement {
    //@ts-ignore
    return this.cueSticks.get(key);
  }

  public getSound(key: string): HTMLAudioElement {
    //@ts-ignore
    return this.sounds.get(key).cloneNode(true) as HTMLAudioElement;
  }

  public playSound(key: string, volume: number): void {
    if (store.state.settings.enableSounds && volume) {
      const sound = this.getSound(key);
      sound.volume = volume;
      sound.play();
    }
  }

  private loadSprite(path: string): Promise<void> {
    const img = new Image();
    this.sprites.set(path, img);

    return new Promise((resolve) => {
      img.onload = () => resolve();
      img.src = sprites.basePath + path;
    });
  }

  private loadCue(path: string): Promise<void> {
    const img = new Image();
    this.sprites.set(path, img);

    return new Promise((resolve) => {
      img.onload = () => resolve();
      img.src = cueSticks.basePath + path;
    });
  }

  private async loadGameSprites(): Promise<void> {
    const loadPromises = Object.values(sprites.paths).map(
      this.loadSprite.bind(this)
    );

    await Promise.all(loadPromises);
  }

  private async loadCueSticks(): Promise<void> {
    const loadPromises = Object.values(cueSticks.paths).map(
      this.loadCue.bind(this)
    );

    await Promise.all(loadPromises);
  }

  private loadSound(path: string): Promise<void> {
    const audio: HTMLAudioElement = new Audio(sounds.basePath + path);
    this.sounds.set(path, audio);

    audio.onerror = () => {
      //@ts-ignore
      console.log('Error ' + audio.error.code + '; details: ' + audio.error.message);
    };

    audio.load();

    return new Promise((resolve) => {
      audio.onloadeddata = () => resolve();
    });
  }

  private async loadGameSounds(): Promise<void> {
    const loadPromises = Object.values(sounds.paths).map(
      this.loadSound.bind(this)
    );

    await Promise.all(loadPromises);
  }
}

export const Assets = new ResourcesSingleton();
